/**
 * PropertyWorkspaceLayout — property-scoped workspace frame.
 *
 * Thin wrapper over AppShell (property mode). AppShell renders the redesign
 * sidebar + topbar and mounts all cross-cutting concerns (trial/demo banners,
 * trial-expired modal, FRAME concierge + ⌘K, onboarding checklist). The nested
 * section routes render through AppShell's <Outlet />.
 *
 * Derives the topbar page title from the current section so every screen has a
 * heading (the design mandates a topbar title on all screens).
 */

import { useLocation } from "react-router"
import { usePropertyContext } from "@/lib/usePropertyContext"
import { AppShell } from "@/components/shell/AppShell"
import type { Crumb } from "@/components/shell/AppTopbar"

const SECTION_TITLES: Record<string, string> = {
  "": "Overview",
  performance: "Revenue",
  listings: "Listings",
  reviews: "Reputation",
  "guest-experience": "Guest Experience",
  tasks: "Tasks",
  settings: "Settings",
  usage: "Usage",
  progress: "Progress",
}

export function PropertyWorkspaceLayout() {
  const { propertyId, property } = usePropertyContext()
  const location = useLocation()

  const rest = location.pathname.split(`/properties/${propertyId}`)[1] || ""
  const section = rest.split("/").filter(Boolean)[0] || ""
  const title = SECTION_TITLES[section] ?? "Overview"

  const breadcrumb: Crumb[] = [
    { label: "Portfolio", to: "/properties" },
    { label: property?.name || propertyId || "Property" },
  ]

  return <AppShell mode="property" propertyId={propertyId} title={title} breadcrumb={breadcrumb} />
}
